<template>
  <el-dialog title="验证手机" :close-on-click-modal="false" :visible.sync="visible" width="480px" :before-close="cancleDialog">
    <el-alert title="检测到您绑定的手机号未验证，请先完成验证" type="warning" :closable="false" show-icon>
    </el-alert>
    <el-form v-loading="loading" :model="ruleForm" :rules="rules" ref="ruleForm" label-width="80px" class="mt-24">
      <el-row>
        <el-col :span="18">
          <el-form-item prop="bindTel" label="验证手机：" size="small">
            <div class="flexNormal" style="align-items:center">
              <el-input v-model="ruleForm.bindTel" placeholder="请输入号码" disabled></el-input>
            </div>
          </el-form-item>
          <el-form-item prop="captcha" label="验证码：" size="small">
            <div class="flexNormal" style="align-items:center">
              <el-input v-model="ruleForm.captcha" maxlength="4" type="number" onkeyup="value=value.replace(/[^\d]/g,'')"></el-input>
            </div>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-button @click="validClientBindTel" :disabled="disabled" type="primary" size="medium" class="ml-16">{{content}}
          </el-button>
        </el-col>
      </el-row>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="cancleDialog" size="medium">取 消</el-button>
      <el-button type="primary" :disabled="bthLoading" @click="confirmDialog" size="medium">确 定</el-button>
    </span>
  </el-dialog>
</template>
<script>
import { confirmValidClientBindTel, validClientBindTel } from '@/views/call/api'

import { debounce } from '@/base/global'

export default {
  name: 'callValidPhone',
  data () {
    var validMobile = (rule, value, callback) => {
      if (value === '' || value === undefined) {
        callback(new Error('请输入号码'))
      } else {
        const reg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/
        if (!reg.test(value)) {
          callback(new Error('请输入正确的号码'))
        } else {
          callback()
        }
      }
    }

    var validCaptcha = (rule, value, callback) => {
      if (value === '' || value === undefined) {
        callback(new Error('请输入验证码'))
      } else {
        if (this.validCaptchaError) {
          callback(new Error('验证码输入错误'))
        } else {
          callback()
        }
      }
    }
    return {
      btnLoading: false,
      visible: false,
      cnoNo: '',
      ruleForm: {
        bindTel: '',
        captcha: ''
      },
      rules: {
        bindTel: [{ required: true, validator: validMobile, trigger: 'blur' }],
        captcha: { required: true, validator: validCaptcha, trigger: 'blur' }
      },
      validCaptchaError: false,
      // 倒计时
      timer: null,
      content: '获取验证码',
      num: 60, // 1分钟
      disabled: false,
      loading: false,
      bthLoading: false
    }
  },
  computed: {
    // ...mapState({
    //   userInfo: state => state.user.userInfo,
    //   seatsInfo: state => state.user.seatsInfo
    // })
  },
  mounted () {
  },
  methods: {
    init () {
      this.cnoNo = ''
      this.ruleForm = {
        bindTel: '',
        captcha: ''
      }
      this.visible = true
      this.loading = true
      this.$store.dispatch('user/queryUserCallClient', { supplierCode: 'rx' }).then(res => {
        if (res.code === '0') {
          const { cnoBindTel, cnoNo, cnoTelType } = res.data
          this.ruleForm.telType = cnoTelType || 1
          this.cnoNo = cnoNo
          this.ruleForm.bindTel = cnoBindTel
        } else {
          this.$message.warning(res.msg)
        }
        setTimeout(() => {
          this.$nextTick(() => {
            this.$refs.ruleForm.clearValidate('bindTel')
          })
        }, 300)
        this.loading = false
      }).catch(_ => { this.loading = false })
    },
    validClientBindTel: debounce(function () {
      this.ruleForm.captcha = ''
      this.btnLoading = true
      validClientBindTel({ supplierCode: 'rx' }).then(res => {
        if (res.code == '0') {
          let num = this.num
          this.disabled = true
          this.timer = setInterval(() => {
            num--
            this.content = `已发送(${num}s)`
            if (num === 0) {
              this.disabled = false
              this.content = '重新获取'
              clearInterval(this.timer)
              this.num = 60
            }
          }, 1000)
        } else {
          this.$message.warning(res.msg)
        }
        this.btnLoading = false
      }).catch(_ => { this.btnLoading = false })
    }, 400),

    resetForm () {
      this.ruleForm = {
        cnoNo: '',
        bindTel: '',
        captcha: ''
      }
      this.$nextTick(() => {
        this.$refs.ruleForm.clearValidate()
      })
      if (!this.timer) {
        this.disabled = false
        this.content = '获取验证码'
      }
    },
    cancleDialog () {
      if (this.timer) {
        clearInterval(this.timer)
        this.timer = null
      }
      this.resetForm()
      this.visible = false
      this.bthLoading = false
    },
    confirmDialog: debounce(function () {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.bthLoading = true
          confirmValidClientBindTel({ captcha: this.ruleForm.captcha, supplierCode: 'rx' }).then(res => {
            this.bthLoading = false
            if (res.code === '0') {
              this.$message.success('绑定成功')
              this.visible = false
              this.resetForm()
            } else {
              this.validCaptchaError = true
              this.$refs.ruleForm.clearValidate('captcha')
              // this.$message.warning(res.msg)
            }
          }).catch(_ => { this.bthLoading = false })
        }
      })
    }, 400)
  }
}
</script>
<style lang="scss" scoped>
.el-button--medium {
  padding: 0 12px;
}

/deep/.el-alert {
  height: 38px;
  padding: 10px 13px;
  color: #3a3a3a;
  font-size: 14px;
  background: #fffbe6;
  border-radius: 10px 10px 10px 0px;
  .el-alert__icon {
    color: #faad14;
  }
  .el-alert__content {
    margin-top: 4px;
  }
}
/deep/ .el-dialog__header {
  padding: 16px 20px;
  .el-dialog__headerbtn{
    top: 18px;
  }
  .el-dialog__close {
    font-size: 22px;
  }
}
/deep/ .el-dialog__body {
  min-height: 200px;
  padding: 16px 20px;
  border-top: 1px solid #e5e5e5;
  border-bottom: 1px solid #e5e5e5;

  .el-form-item__label {
    padding-right: 0;
  }
}
/deep/ .el-dialog__footer {
  padding: 20px;
  .el-button + .el-button {
    margin-left: 24px;
    min-width: 60px;
  }
}
</style>
